import { Button, Stack, Step, StepLabel, Stepper } from '@mui/material'
import { FC, useContext, useState } from 'react'

import { CenteredLoading } from '../../components'
import ShopContactBox from '../../components/CustomerPortal/ShopContactBox'
import ServicesSummaryPanel from '../../components/InspectionRelatedPanel/ServicesSummaryPanel'
import SummaryPanel from '../../components/SharedUI/SummaryPanel/SummaryPanel'
import { PaymentPortalContext } from '../../providers/PaymentPortalProvider/PaymentPortalProvider'
import PaymentCreated from './PaymentCreated'
import { PaymentForm } from './PaymentForm'
import useExistingPayment from './useExistingPayment'

enum PaymentStep {
  Review = 0,
  Payment = 1,
  Confirmation = 2
}

const stepLabels = Object.values(PaymentStep)
  .filter((value) => typeof value === 'number')
  .sort()
  .map((num) => PaymentStep[num as PaymentStep])

const MobilePortalBody: FC = () => {
  const { repairOrder, services, shop } = useContext(PaymentPortalContext)
  const existingPayment = useExistingPayment()
  const [hasReviewed, setHasReviewed] = useState<boolean>(false)
  const getActiveStep = () => {
    if (existingPayment) {
      return PaymentStep.Confirmation
    } else if (hasReviewed) {
      return PaymentStep.Payment
    } else {
      return PaymentStep.Review
    }
  }

  const activeStep = getActiveStep()

  const getStepContent = () => {
    switch (activeStep) {
      case PaymentStep.Review: {
        return (
          <Stack spacing={2}>
            <ShopContactBox shop={shop!} />
            <ServicesSummaryPanel services={services!} showPrice />
            <SummaryPanel repairOrder={repairOrder!} readOnly />
            <Button variant="outlined" onClick={() => setHasReviewed(true)}>
              Continue to Payment
            </Button>
          </Stack>
        )
      }
      case PaymentStep.Payment: {
        return <PaymentForm handleBack={() => setHasReviewed(false)} />
      }
      default: {
        return existingPayment ? (
          <PaymentCreated payment={existingPayment} />
        ) : (
          <CenteredLoading />
        )
      }
    }
  }

  return (
    <Stack spacing={2}>
      <Stepper activeStep={activeStep}>
        {stepLabels.map((stepLabel) => (
          <Step key={stepLabel}>
            <StepLabel>{stepLabel}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {getStepContent()}
    </Stack>
  )
}

export default MobilePortalBody
